// src/components/ProjectHistoryFilters.jsx

import React, { useState, useEffect } from 'react';
import { Box, TextField, Autocomplete, Stack, Button, Typography } from '@mui/material';
import './ProjectHistoryFilters.css'; // Import the CSS file

// Function to extract unique values from logs
const extractUniqueValues = (logs, key) => {
  const uniqueValues = [...new Set(logs.map((log) => log[key]))];
  return uniqueValues.filter((value) => value && value !== 'N/A'); // Filter out invalid values like 'N/A'
};

export default function ProjectHistoryFilters({ logs, onFilterChange }) {
  const [logType, setLogType] = useState('');
  const [category, setCategory] = useState('');
  const [entityId, setEntityId] = useState('');
  const [modelType, setModelType] = useState('');

  // Predefined enum options for logType and category
  const logTypeOptions = ['INFO', 'ERROR', 'WARNING', 'SUCCESS'];
  const categoryOptions = ['REVIEW_ASSIGNED', 'SUBMISSION_CREATED', 'REVIEW_COMPLETED', 'SUBMISSION_DELETED'];

  // Extract unique values from logs for dynamic filtering
  const uniqueEntityIds = extractUniqueValues(logs, 'entityId');
  const uniqueModelTypes = extractUniqueValues(logs, 'modelType');

  const handleChange = (name, value) => {
    // Update the filter state and trigger parent callback
    if (name === 'logType') {
      setLogType(value);
    } else if (name === 'category') {
      setCategory(value);
    } else if (name === 'entityId') {
      setEntityId(value);
    } else if (name === 'modelType') {
      setModelType(value);
    }
    onFilterChange(name, value); // Call parent to update filtered data
  };

  return (
    <Box sx={{ p: 2 }} className="filter-container">
      {/* Log Type Autocomplete */}
      <Autocomplete
        value={logType}
        onChange={(event, newValue) => handleChange('logType', newValue)}
        options={logTypeOptions}
        renderInput={(params) => <TextField {...params} label="Log Type" />}
        isOptionEqualToValue={(option, value) => option === value}
        freeSolo
        className="filter-item"
      />

      {/* Category Autocomplete */}
      <Autocomplete
        value={category}
        onChange={(event, newValue) => handleChange('category', newValue)}
        options={categoryOptions}
        renderInput={(params) => <TextField {...params} label="Category" />}
        isOptionEqualToValue={(option, value) => option === value}
        freeSolo
        className="filter-item"
      />

      {/* EntityId Filter */}
      <Autocomplete
        value={entityId}
        onChange={(event, newValue) => handleChange('entityId', newValue)}
        options={uniqueEntityIds}
        renderInput={(params) => <TextField {...params} label="Entity ID" />}
        isOptionEqualToValue={(option, value) => option === value}
        freeSolo
        className="filter-item"
      />

      {/* Model Type Filter */}
      <Autocomplete
        value={modelType}
        onChange={(event, newValue) => handleChange('modelType', newValue)}
        options={uniqueModelTypes}
        renderInput={(params) => <TextField {...params} label="Model Type" />}
        isOptionEqualToValue={(option, value) => option === value}
        freeSolo
        className="filter-item"
      />
    </Box>
  );
}
